import Assignments from "./Assignments";

export default Assignments;